import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class RequestHeaderService {
  private _requestHeaderValue: string | null = null;

  public setRequestHeaderValue(value: string) {
    this._requestHeaderValue = value;
  }

  public getRequestHeaderValue(): string | null {
    return this._requestHeaderValue;
  }
}
